import { useAuthStore } from '@/stores/auth'
import { dynamicRouteMap } from './index'

const WHITE_LIST = ['/login', '/403', '/404']
let dynamicRoutesAdded = false

/**
 * 将菜单树转为 Vue Router 路由（扁平化注册到 /layout 下）
 */
function buildRoutes(menus) {
  const routes = []
  function walk(nodes) {
    nodes.forEach((menu) => {
      if (menu.type === 1 && menu.component && dynamicRouteMap[menu.component]) {
        routes.push({
          path: menu.path,
          name: menu.name,
          component: dynamicRouteMap[menu.component],
          meta: {
            title: menu.name,
            icon: menu.icon,
            permission: menu.permission,
          },
        })
      }
      if (menu.children?.length) walk(menu.children)
    })
  }
  walk(menus)
  return routes
}

export function setupRouterGuard(router) {
  router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore()

    document.title = to.meta?.title ? `${to.meta.title} - 管理后台` : '管理后台'

    if (WHITE_LIST.includes(to.path)) {
      // 已登录时访问登录页直接跳首页
      if (to.path === '/login' && authStore.isLoggedIn) {
        return next({ path: '/shop', replace: true })
      }
      return next()
    }

    if (!authStore.isLoggedIn) {
      return next({ path: '/login', query: { redirect: to.fullPath } })
    }

    // 动态添加路由
    if (!dynamicRoutesAdded) {
      const childRoutes = buildRoutes(authStore.menus || [])
      // 如果已存在同名路由先删除，避免重复
      if (router.hasRoute('Layout')) {
        router.removeRoute('Layout')
      }
      router.addRoute({
        path: '/',
        name: 'Layout',
        component: () => import('@/layouts/index.vue'),
        redirect: '/shop',
        children: [
          ...childRoutes,
        ],
      })
      dynamicRoutesAdded = true
      // 必须重新导航，让新注册的路由生效（replace 避免增加历史记录）
      return next({ path: to.fullPath, replace: true })
    }

    // 路由级权限校验
    if (to.meta?.permission && !authStore.hasPermission(to.meta.permission)) {
      return next({ path: '/403', replace: true })
    }

    next()
  })
}

export function resetDynamicRoutes() {
  dynamicRoutesAdded = false
}
